import { useMatches } from 'react-router-dom';

const isRoutePathHandle = (handle: unknown): handle is { routePath: string } =>
  typeof handle === 'object' && handle !== null && 'routePath' in handle;

const useRoutePath = (): string | undefined => {
  const matches = useMatches();
  const match = matches[matches.length - 1];
  return isRoutePathHandle(match.handle) ? match.handle.routePath : undefined;
};

export default useRoutePath;
